import { ColumnTypeEnum } from '@y42/json-schema';
import { TypescriptTypeEnum } from '@y42/monaco-typescript-types';

// TODO: what with commented cases?
export const ColumnTypeToTypescriptTypeConverter = (variableType: ColumnTypeEnum) => {
  switch (variableType) {
    case ColumnTypeEnum.Struct:
      return TypescriptTypeEnum.ANY;
    case ColumnTypeEnum.Boolean:
      return TypescriptTypeEnum.BOOLEAN;
    case ColumnTypeEnum.Array:
      return TypescriptTypeEnum.ANY_ARRAY;
    case ColumnTypeEnum.ArrayString:
      return TypescriptTypeEnum.STRING_ARRAY;
    case ColumnTypeEnum.Numeric:
    case ColumnTypeEnum.Integer:
    case ColumnTypeEnum.Float:
      return TypescriptTypeEnum.NUMBER;
    case ColumnTypeEnum.String:
      return TypescriptTypeEnum.STRING;
    // case ColumnTypeEnum.null:
    //   return TypescriptTypeEnum.NULL;
    case ColumnTypeEnum.Date:
      return TypescriptTypeEnum.DATE;
    case ColumnTypeEnum.Datetime:
      return TypescriptTypeEnum.DATETIME;
    case ColumnTypeEnum.Timestamp:
      return TypescriptTypeEnum.TIMESTAMP;
    // TODO: what should ColumnTypeEnum.Time be treated as?
    default:
      return TypescriptTypeEnum.ANY;
  }
};
